import axios from "axios";
import api from "@/components/api.js";
import i18n from "@/locales/index.js";

const state = () => ({
    selectedDetailsOrder: null,
});

const mutations = {
    setSelectedDetailsOrder(state, value) {
        state.selectedDetailsOrder = value;
    },
};

const actions = {
    async sendOrderDetailsMessage({ commit, dispatch }, payload) {
        if (!window) return;
        const baseUrl = window.location.origin;
        try {
            const requestData = new FormData();
            requestData.append("order_id", payload.orderId);
            const response = await axios.post(
                `${baseUrl}${api.orders.sendOrderDetailsMessage}`,
                requestData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        locale: i18n?.global?.locale?.value ?? "ar",
                    },
                }
            );
            const { data: responseData } = response;
            dispatch(
                "Toasts/addToast",
                {
                    message: responseData.msg
                        ? responseData?.msg
                        : responseData.success
                        ? i18n.global.t("Send Order Details Message Success")
                        : i18n.global.t("Send Order Details Message Fail"),
                    type: responseData.success ? "success" : "error",
                },
                { root: true }
            );
        } catch (error) {
            dispatch(
                "Toasts/addToast",
                {
                    message: i18n.global.t("Send Order Details Message Fail"),
                    type: "error",
                },
                { root: true }
            );
        }
    },
    setSelectedDetailsOrder({ commit }, payload) {
        commit("setSelectedDetailsOrder", payload);
    },
};

const getters = {
    selectedDetailsOrder(state) {
        return state.selectedDetailsOrder;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
